/**
 * Indirection over `window.location.reload()` so tests can `jest.mock` it —
 * jsdom's `window.location` can't be reliably redefined between tests.
 */
export const reloadPage = () => {
  window.location.reload();
};
